export default [
  [
    {
      id: 'trailerPlate',
      label: 'ทะเบียนหาง',
      span: 12,
      type: 0,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'ทะเบียนหาง *' } },
    }, {
      id: 'chassisNumber',
      label: 'เลขคัตซี',
      span: 12,
      type: 0,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'เลขคัตซี' } },
    },
  ], [
    {
      id: 'truckTypeId',
      label: 'ชนิดรถ *',
      span: 8,
      type: 6,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'ชนิดรถ' } },
      children: [],
    },
    {
      id: 'status',
      label: 'สถานะ',
      span: 8,
      type: 2,
      props: { margin: '0 40px 0 0', width: '240px' },
      children: [],
    },
  ],
]
